export const dslTranslationsSectionMessagesEn = {
  // Cohort Builder - CohortDefinitionDSLSection
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.title': 'Cohort definition DSL',
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLMainMsg': 'No DSL value',
  'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLSubMsg':
    'Once a simple event, derived event, or subject variable is defined, a DSL value will be generated.',

  // Cohort Builder - CohortDefinitionSQLSection
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.title': 'Cohort definition SQL',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.noSQLMainMsg': 'No SQL value',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.noSQLSubMsg':
    'Once a simple event, derived event, or subject variable is defined, a DSL value will be generated.',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.translating': 'Generating SQL...',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.translatingSubMessage':
    'Please wait while the SQL is generated.',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.error': 'Error generating SQL',
  'projects.cohortBuilderPage.cohortDefinitionSQLSection.errorSubMessage':
    'There was an error generating the SQL. Please try again.',

  // Cohort Builder - CohortDefinitionDSLToUISection
  'projects.cohortBuilderPage.cohortDefinitionDSLToUISection.title': 'Cohort definition DSL to UI',
};
